__turbopack_context__.v({
  "body": "drawer-module__okveUa__body",
  "content": "drawer-module__okveUa__content",
  "header": "drawer-module__okveUa__header",
  "title": "drawer-module__okveUa__title",
});
